import React from 'react';
import Component from '../../components/Component';
import DbInfo from '../../dbinfo';
import * as Constants from '../../constants';
import Toolbar from '../../components/Toolbar';
import {Button} from 'react-bootstrap';
import {RxForm, FormManager, FormField, FormRow, Multiform} from 'reactis-forms';
import {TextInput, TextArea, DatePicker, RadioList, ImageUpload, FileUpload, Select, Checkbox} from 'reactis-inputs';
import {actions as formactions} from 'reactis-forms';
import * as clientactions from '../../redux/modules/client';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {AlertWindow, ConfirmWindow} from 'reactis-modal';
import FormDB from '../../components/FormDB';
import {Loader, LoadingButton} from 'reactis-loader';
import ActionButton from '../../components/ActionButton';
import SaveButton from '../../components/SaveButton';
import ClientLookup from '../../components/Form/ClientLookup';
import ButtonToolbar from '../../components/ButtonToolbar';

@connect((state, props) => {
		return {
			form: state.forms.get('tab_' + props.tabid)
		};
	},
	(dispatch) => {
		return {
			actions: bindActionCreators(formactions, dispatch),
			clientActions: bindActionCreators(clientactions, dispatch)
		};
	}, null, {withRef: true })
export default class Form extends FormDB {

	constructor(props, context) {
		super(props, context);

		this.api = {
			fetch: 'client.fetch',
			save: 'client.save',
			remove: 'client.delete'
		};

		this.changeEvent = 'client.change';

		this.messages = {
			remove: 'Opravdu chcete firmu odstranit?',
			notfound: 'Firma nenalezena!'
		};


		this.schema = {
			title: {
				class: TextInput,
				label: 'Název',
				autoFocus: !props.id,
				rules: {
					presence: {message: 'Zadejte název!'}
				}
			},
      default_training_years: {
        class: Select,
        options: DbInfo.TrainingDuration,
        label: 'Výchozí platnost školení',
        clearable: false,
        value: 1
      },
			ic: {
				class: TextInput,
				label: 'IČ',
				style: {width: 120},
				onBlur: (value) => {
					//alert(value);
				}
			},

			dic: {
				class: TextInput,
				label: 'DIČ',
				style: {width: 120}
			},

			email: {
				class: TextInput,
				label: 'E-mail'
			},

      email2: {
        class: TextInput,
        label: 'E-maily - kopie',
        help: 'Více adres oddělte čárkou nebo středníkem.'
      },

			contact_name: {
				class: TextInput,
				label: 'Kontaktní osoba'
			},

			phone: {
				class: TextInput,
				label: 'Telefon'
			},

			street: {
				class: TextInput,
				label: 'Ulice'
			},

			city: {
				class: TextInput,
				label: 'Město',
				style: {width: 250}
			},

			zip: {
				class: TextInput,
				label: 'PSČ',
				style: {width: 80}
			},

			invoice_street: {
				class: TextInput,
				label: 'Ulice'
			},

			invoice_city: {
				class: TextInput,
				label: 'Město',
				style: {width: 250}
			},

			invoice_zip: {
				class: TextInput,
				label: 'PSČ',
				style: {width: 80}
			},

			/*image: {
				class: ImageUpload,
				label: 'Logo'
			},*/

			notice: {
				class: TextArea,
				label: 'Poznámka',
				style: { height: '100px'}
			},
			files: {
				class: FileUpload,
				label: 'Přílohy'
			}
		};
		this.form = new FormManager(this.schema);
	}

	componentDidMount() {
		this.form.on('change', (key, value, values) => {
			if (key == 'title') {
				this.title = value;
			}
			this.changed = true;
		});
		super.componentDidMount();
	}

	updateTab(data) {
		this.props.updateTab({title: data.title});
	}

	onSave(data) {
		if (this.props.onSave) {
			this.form.reset();
			this.props.onSave(data);
		}
	}

	handleAres(e) {
		e.preventDefault();
		const ico = this.form.getValues().get('ic');
		this.getAres(ico);
	}
	getAres(ico) {
		this.props.clientActions.getAres(ico).then((res) => {
			const data = res.result;
			if (!data.status) {
				alert('Firmu se nepodařilo v registru najít.');
			}
			else {
				this.form.setValue({
					title: data.ares.firm,
					street: data.ares.street,
					city: data.ares.city,
					zip: data.ares.zip,
          dic: data.ares.dic,
					invoice_street: data.ares.street,
					invoice_city: data.ares.city,
					invoice_zip: data.ares.zip
				})
			}
		});
	}

	render() {

		const loading = !!(this.props.form && this.props.form.get('saving'));
		const canEdit = true || this.user.isAllowed('user', 'update');
		const canDelete = true || this.user.isAllowed('user', 'delete');
		const isNew = !this.props.id;

		const saveCloseButton = <LoadingButton
			disabled={!canEdit}
			title="Uložit"
			loading={loading}
			onClick={()=>this.save(true)}
		/>;

		const toolbar = [
			{
				title: 'Uložit',
				icon: 'fa fa-check',
				loading: loading,
				bsStyle: 'primary',
				onClick: () => this.save(true)
			},
			{
				title: 'Uložit a pokračovat v editaci',
				icon: 'fa fa-check',
				loading: loading,
				bsStyle: 'default',
				onClick: () => this.save()
			},
			{
				title: 'Uložit a nový',
				icon: 'fa fa-file-o',
				loading: loading,
				bsStyle: 'default',
				onClick: ()=>this.save(true, false, {}, () => this.props.newTab())
			},
			{
				divider: true
			},
			{
				title: 'Odstranit',
				icon: 'fa fa-trash-o',
				bsStyle: 'danger',
				color: '#A00',
				onClick: ()=>this.remove()
			}
		];

		return (
			<div style={{position:'relative'}}>
				<Loader visible={!!(this.props.form && this.props.form.get('loading'))} />
				<RxForm ref="form" form={this.form} id={'tab_' + this.props.tabid}>
					{!this.props.popup &&
					<Toolbar title="Firma">
						<ButtonToolbar buttons={toolbar} />
					</Toolbar>
					}
					<div className="row">
            <div className={!this.props.popup ? 'col-xs-8' : ''}>
              <legend>Základní údaje</legend>
              <table className="form">
                <tbody>
                <FormRow name="title" labelWidth={135}/>
                <FormRow name="phone"/>
                <FormRow name="email"/>
                <FormRow name="email2"/>
                <FormRow name="contact_name"/>
                <FormRow label="IČ">
                  <FormField name="ic"/>
                  <Button onClick={(e) => this.handleAres(e)} bsStyle="default" href="#"
                          style={{marginTop: -1, marginLeft: 4}}>
                    <i className="clip-download"></i> Načíst z ARESu
                  </Button>
                  &nbsp; DIČ: <FormField name="dic"/>
                </FormRow>
                </tbody>
              </table>

              <legend>Adresa</legend>
              <table className="form">
                <tbody>
                <FormRow name="street"/>
                <FormRow label="Město">
                  <FormField name="city"/> &nbsp; PSČ: <FormField name="zip"/>
                </FormRow>
                </tbody>
              </table>

              <legend>Fakturační adresa</legend>
              <table className="form">
                <tbody>
                <FormRow name="invoice_street"/>
                <FormRow label="Město">
                  <FormField name="invoice_city"/> &nbsp; PSČ: <FormField name="invoice_zip"/>
                </FormRow>
                </tbody>
              </table>

              <legend>Školení</legend>
              <table className="form">
                <tbody>
                <FormRow name="default_training_years" labelWidth={160}/>
                </tbody>
              </table>

              <legend>Poznámka</legend>
              <table className="form">
                <tbody>
                <FormRow name="notice" labelWidth={135}/>
                <FormRow name="files"/>
                </tbody>
              </table>
            </div>
          </div>

          {!this.props.popup &&
            <div style={{textAlign: 'right'}}>
              {saveCloseButton}
            </div>}


          {this.props.popup &&
            <div className="modal-footer" style={{margin: -20, marginTop: 20}}>
						<Button onClick={() => this.props.onClose()} bsStyle="link">Storno</Button>
						{saveCloseButton}
					</div>}
				</RxForm>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/containers/Client/Form.js